import React from 'react';
import RemoveButton from './RemoveButton';

const ButtonSettings = ({ formData, updateFormData }) => {
  const MAX_BUTTONS = 3;

  // Initialiser les boutons CTA s'ils n'existent pas
  const buttons = formData.ctaButtons || [];

  // Fonction pour ajouter un nouveau bouton
  const addButton = () => {
    if (buttons.length >= MAX_BUTTONS) {
      return;
    }
    const newButton = {
      id: Date.now().toString(),
      text: 'Mon bouton',
      link: 'https://example.com',
      textColor: '#ffffff',
      backgroundColor: '#ff6b35',
      fontSize: '14',
      fontFamily: 'Arial, sans-serif',
      fontWeight: 'normal',
      fontStyle: 'normal',
      borderRadius: '5',
      padding: '10',
      position: 'center',
      width: 'auto',
      height: 'auto'
    };
    
    const updatedButtons = [...buttons, newButton];
    updateFormData('ctaButtons', updatedButtons);
  };

  // Fonction pour supprimer un bouton
  const removeButton = (buttonId) => {
    const updatedButtons = buttons.filter(button => button.id !== buttonId);
    updateFormData('ctaButtons', updatedButtons);
  };

  // Fonction pour mettre à jour un bouton
  const updateButton = (buttonId, field, value) => {
    const updatedButtons = buttons.map(button => 
      button.id === buttonId ? { ...button, [field]: value } : button
    );
    updateFormData('ctaButtons', updatedButtons);
  };

  return (
    <div className="form-section-content">
      <h3 className="section-title">Boutons d'action (CTA)</h3>
      
      {/* Liste des boutons existants */}
      {buttons.length > 0 && (
        <div style={{ marginBottom: '30px' }}>
          {buttons.map((button, index) => (
            <div key={button.id} style={{ 
              border: '1px solid var(--color-border)', 
              borderRadius: '8px', 
              padding: '20px', 
              marginBottom: '20px',
              backgroundColor: 'var(--color-background)',
              position: 'relative'
            }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '15px' 
              }}>
                <h4 style={{ margin: 0, color: 'var(--color-text)' }}>
                  Bouton {index + 1}
                </h4>
                <RemoveButton 
                  onClick={() => removeButton(button.id)} 
                  style={{
                    position: 'static',
                    background: 'transparent',
                    color: '#888888',
                    border: 'none',
                    borderRadius: '4px',
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'normal',
                    transition: 'all 0.2s ease'
                  }}
                />
              </div>

              {/* Contenu du bouton */}
              <div className="form-group">
                <label className="form-label">Texte du bouton</label>
                <input
                  type="text"
                  className="form-input"
                  value={button.text}
                  onChange={(e) => updateButton(button.id, 'text', e.target.value)}
                  placeholder="Texte affiché sur le bouton"
                />
              </div>

              {/* Lien de redirection */}
              <div className="form-group">
                <label className="form-label">Lien de redirection</label>
                <input
                  type="url"
                  className="form-input"
                  value={button.link}
                  onChange={(e) => updateButton(button.id, 'link', e.target.value)}
                  placeholder="https://example.com"
                />
              </div>

              {/* Couleurs */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div className="form-group">
                  <label className="form-label">Couleur du texte</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <input
                      type="color"
                      value={button.textColor}
                      onChange={(e) => updateButton(button.id, 'textColor', e.target.value)}
                      style={{ width: '40px', height: '40px', border: 'none', borderRadius: '4px' }}
                    />
                    <input
                      type="text"
                      className="form-input"
                      value={button.textColor}
                      onChange={(e) => updateButton(button.id, 'textColor', e.target.value)}
                      placeholder="#ffffff"
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Couleur de fond</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <input
                      type="color"
                      value={button.backgroundColor}
                      onChange={(e) => updateButton(button.id, 'backgroundColor', e.target.value)}
                      style={{ width: '40px', height: '40px', border: 'none', borderRadius: '4px' }}
                    />
                    <input
                      type="text"
                      className="form-input"
                      value={button.backgroundColor}
                      onChange={(e) => updateButton(button.id, 'backgroundColor', e.target.value)}
                      placeholder="#ff6b35"
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>
              </div>

              {/* Police et style */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                <div className="form-group">
                  <label className="form-label">Taille de police</label>
                  <select
                    className="form-input"
                    value={button.fontSize}
                    onChange={(e) => updateButton(button.id, 'fontSize', e.target.value)}
                  >
                    <option value="12">12px</option>
                    <option value="13">13px</option>
                    <option value="14">14px</option>
                    <option value="15">15px</option>
                    <option value="16">16px</option>
                    <option value="18">18px</option>
                    <option value="20">20px</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Graisse</label>
                  <select
                    className="form-input"
                    value={button.fontWeight}
                    onChange={(e) => updateButton(button.id, 'fontWeight', e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="bold">Gras</option>
                    <option value="600">Semi-gras</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Style</label>
                  <select
                    className="form-input"
                    value={button.fontStyle}
                    onChange={(e) => updateButton(button.id, 'fontStyle', e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="italic">Italique</option>
                  </select>
                </div>
              </div>

              {/* Police */}
              <div className="form-group">
                <label className="form-label">Police</label>
                <select
                  className="form-input"
                  value={button.fontFamily}
                  onChange={(e) => updateButton(button.id, 'fontFamily', e.target.value)}
                >
                  <option value="Arial, sans-serif">Arial</option>
                  <option value="Helvetica, sans-serif">Helvetica</option>
                  <option value="Georgia, serif">Georgia</option>
                  <option value="Times New Roman, serif">Times New Roman</option>
                  <option value="Verdana, sans-serif">Verdana</option>
                  <option value="Tahoma, sans-serif">Tahoma</option>
                  <option value="Trebuchet MS, sans-serif">Trebuchet MS</option>
                  <option value="Courier New, monospace">Courier New</option>
                </select>
              </div>

              {/* Forme et dimensions */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div className="form-group">
                  <label className="form-label">Arrondi des coins (px)</label>
                  <input
                    type="number"
                    className="form-input"
                    value={button.borderRadius}
                    onChange={(e) => updateButton(button.id, 'borderRadius', e.target.value)}
                    min="0"
                    max="50"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Espacement interne (px)</label>
                  <input
                    type="number"
                    className="form-input"
                    value={button.padding}
                    onChange={(e) => updateButton(button.id, 'padding', e.target.value)}
                    min="5"
                    max="30"
                  />
                </div>
              </div>

              {/* Position */}
              <div className="form-group">
                <label className="form-label">Position dans la signature</label>
                <select
                  className="form-input"
                  value={button.position}
                  onChange={(e) => updateButton(button.id, 'position', e.target.value)}
                >
                  <option value="left">À gauche</option>
                  <option value="center">Au centre</option>
                  <option value="right">À droite</option>
                </select>
              </div>

              {/* Aperçu du bouton */}
              <div className="form-group">
                <label className="form-label">Aperçu</label>
                <div style={{ 
                  padding: '20px', 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '8px',
                  textAlign: button.position 
                }}>
                  <a
                    href={button.link}
                    style={{
                      display: 'inline-block',
                      padding: `${button.padding}px ${parseInt(button.padding) * 1.5}px`,
                      backgroundColor: button.backgroundColor,
                      color: button.textColor,
                      textDecoration: 'none',
                      borderRadius: `${button.borderRadius}px`,
                      fontSize: `${button.fontSize}px`,
                      fontFamily: button.fontFamily,
                      fontWeight: button.fontWeight,
                      fontStyle: button.fontStyle,
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'opacity 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                    onMouseLeave={(e) => e.target.style.opacity = '1'}
                  >
                    {button.text}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Message si aucun bouton */}
      {buttons.length === 0 && (
        <p style={{ 
          color: 'var(--color-text-light)', 
          fontStyle: 'italic',
          marginBottom: '20px' 
        }}>
          Aucun bouton d'action ajouté. Utilisez le bouton ci-dessous pour en créer un.
        </p>
      )}

      {/* Bouton d'ajout */}
      <button
        type="button"
        onClick={addButton}
        disabled={buttons.length >= MAX_BUTTONS}
        style={{
          background: buttons.length >= MAX_BUTTONS ? 'var(--color-border)' : 'var(--color-primary)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          padding: '10px 15px',
          cursor: buttons.length >= MAX_BUTTONS ? 'not-allowed' : 'pointer',
          opacity: buttons.length >= MAX_BUTTONS ? 0.7 : 1,
          fontSize: '14px',
          fontWeight: '500',
          marginTop: '15px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          justifyContent: 'center'
        }}
      >
        <span style={{ fontSize: '18px' }}>+</span>
        Ajouter un bouton d'action
      </button>

      {buttons.length >= MAX_BUTTONS && (
        <p style={{
          color: 'var(--color-text-light)',
          fontStyle: 'italic',
          marginTop: '10px'
        }}>
          Limite atteinte: vous pouvez créer au maximum {MAX_BUTTONS} boutons d'action.
        </p>
      )}
    </div>
  );
};

export default ButtonSettings;
